import "bootstrap/dist/css/bootstrap.min.css";
import "typeface-inter"; //font
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/pages/Home";
import About from "./Components/pages/About";
import Work from "./Components/pages/Work";
import Contact from "./Components/pages/Contact";
import { lightTheme, darkTheme } from "./styles/themes";
import { GlobalStyle } from "./styles/GlobalStyle";
import { ThemeProvider as StyledThemeProvider } from "styled-components"; //ThemeProvider applies theme to entire app, avoid conflicts with  custom, that's why its casted
import { ThemeProvider, useTheme } from "./context/ThemeContext"; //ThemeProvider contains custom theme
import ScrollToTop from "./utils/ScrollToTop";
import "./App.css";
import useLenis from "./hooks/useLenis";
// import TestPage from "./Components/pages/TestPage";
import DefaultSpace from "./Components/layouts/DefaultSpace";
import ProjectView from "./Components/pages/ProjectView";
import AdminProjectDashboard from "./Components/pages/AdminProjectDashboard";
import PortfolioLayout from "./Components/layouts/PortfolioLayout";
import DashboardLayout from "./Components/layouts/DashboardLayout";
import LoginSignUp from "./Components/pages/LoginAndCreateAcc";
import DashboardLanding from "./Components/pages/DashboardLanding";
import DashboardProfile from "./Components/pages/DashboardProfile";
import InsightAndAnalysis from "./Components/pages/InsightsAandAnalysisPage";
import ProtectedRoute from "./utils/RouteGuard";
import { AuthProvider } from "./context/AuthContext";
import ResetPassword from "./Components/pages/ResetPasswordLayout";

const ThemedApp: React.FC = () => {
  useLenis(); // Initialize Lenis on scroll
  const { theme } = useTheme();

  return (
    <StyledThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyle />
      <Router>
        <AuthProvider>
        <ScrollToTop />
        <Routes>
          {/* Portfolio routes */}
          <Route
            path="/"
            element={
              <PortfolioLayout>
                <Home />
              </PortfolioLayout>
            }
          />
          <Route
            path="/about"
            element={
              <PortfolioLayout>
                <About />
              </PortfolioLayout>
            }
          />
          {/* <Route path="/test" element={    <PortfolioLayout>
                <TestPage />
              </PortfolioLayout>} /> */}
          <Route
            path="/work"
            element={
              <PortfolioLayout>
                <Work />
              </PortfolioLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <PortfolioLayout>
                <Contact />
              </PortfolioLayout>
            }
          />
          <Route
            path="/project-view/:projectId"
            element={
              <PortfolioLayout>
                <ProjectView />
              </PortfolioLayout>
            }
          />

          {/* /////////////////////////////////////////////////////////// */}
          {/* Dashboard Routes */}
          <Route
            path="/dashboard/login"
            element={
              <DashboardLayout conditionCenter="conditionallyCenter">
                <LoginSignUp isLogin={true} />
              </DashboardLayout>
            }
          />
          <Route
            path="/dashboard/register"
            element={
              <DashboardLayout conditionCenter="conditionallyCenter">
                <LoginSignUp isLogin={false} />
              </DashboardLayout>
            }
          />
          <Route
            path="/dashboard/forgot-password"
            element={
              <DashboardLayout conditionCenter="conditionallyCenter">
                <ResetPassword isResetForm={false} />
              </DashboardLayout>
            }
          />
          <Route
            path="/dashboard/reset-password"
            element={
              <DashboardLayout conditionCenter="conditionallyCenter">
                <ResetPassword isResetForm={true} />
              </DashboardLayout>
            }
          />
          <Route element={<ProtectedRoute />}>
            <Route
              path="/dashboard/landing"
              element={
                <DashboardLayout>
                  <DashboardLanding />
                </DashboardLayout>
              }
            />
            <Route
              path="/dashboard/landing/project-view/:projectId"
              element={
                <DashboardLayout>
                  <ProjectView />
                </DashboardLayout>
              }
            />
            <Route
              path="/dashboard/landing/add-project"
              element={
                <DashboardLayout>
                  <AdminProjectDashboard />
                </DashboardLayout>
              }
            />
            <Route
              path="//dashboard/landing/edit-project/:projectId"
              element={
                <DashboardLayout>
                  <AdminProjectDashboard />
                </DashboardLayout>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <DashboardLayout>
                  <DashboardProfile />
                </DashboardLayout>
              }
            />
            <Route
              path="/dashboard/insights-and-analytics"
              element={
                <DashboardLayout>
                  <InsightAndAnalysis />
                </DashboardLayout>
              }
            />
          </Route>
          <Route path="*" element={<DefaultSpace />} />{" "}
          {/* Catch-all route from portfolio*/}
        </Routes>
        </AuthProvider>
      </Router>
    </StyledThemeProvider>
  );
};

const App: React.FC = () => (
  <ThemeProvider>
      <ThemedApp />
  </ThemeProvider>
);

export default App;
